/**
 * Supported bug bounty platforms and their URL patterns.
 */
const SUPPORTED_PLATFORMS = [
  { name: 'hackerone', pattern: /^https?:\/\/(www\.)?hackerone\.com\/[a-zA-Z0-9_-]+\/?(\?.*)?$/ },
  { name: 'bugcrowd', pattern: /^https?:\/\/(www\.)?bugcrowd\.com\/[a-zA-Z0-9_-]+\/?(\?.*)?$/ },
  { name: 'intigriti', pattern: /^https?:\/\/(www\.)?intigriti\.com\/[a-zA-Z0-9_-]+\/?(\?.*)?$/ },
] as const;

export type BugBountyPlatform = (typeof SUPPORTED_PLATFORMS)[number]['name'];

/**
 * Validates that a URL belongs to a supported bug bounty platform.
 * Returns the platform name if valid, null otherwise.
 */
export function parseBugBountyUrl(url: string): { platform: BugBountyPlatform; handle: string } | null {
  const trimmed = url.trim();
  if (!trimmed) return null;

  for (const { name, pattern } of SUPPORTED_PLATFORMS) {
    if (pattern.test(trimmed)) {
      const handle = trimmed
        .replace(/\/$/, '')
        .split('/')
        .pop()
        ?.split('?')[0];
      if (handle) {
        return { platform: name, handle };
      }
    }
  }

  return null;
}

/**
 * Returns whether a URL is a valid bug bounty platform URL.
 */
export function isValidBugBountyUrl(url: string): boolean {
  return parseBugBountyUrl(url) !== null;
}
